import './core/lazy_use';
import 'element-ui/lib/theme-chalk/index.css';
import '@/style/index.scss'; // global css
//@ts-ignore
import directive from './directive/index.js';
import Vue from 'vue';
import VueAxios from 'vue-axios';

import App from './App.vue';
import router from './router';
import store from './store';
import axios from './utils/request';
Vue.config.productionTip = false;
Vue.use(VueAxios, axios);
Vue.use(directive)

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#main-app');
